export function anchor_scrolling() {
  $('a[href^="#anchor-"]').click(function (e) {
    e.preventDefault();

    let spacer = 0
    let aTag = $(this).attr('href').replace('#', '.');
    let anchorIndex = $('.section').index(($(this).closest('.section')));
    let stickyIndex = $('.section').index($('.pharmacy-search-component-sticky-form'));
    let anchorTargetIndex = $('.section').index($(aTag).closest('.section'));

    if ($('.header').length > 0) {
      spacer += $('.header').outerHeight();
    }

    if ($('body').hasClass('show-app-banner') && $('.app-banner').length > 0) {
      spacer += $('.app-banner').outerHeight();
    }

    if ($('.pharmacy-search-component-sticky-form').length > 0 && $('.pharmacy-search-component-sticky-form').hasClass('sticky')) {
      if (stickyIndex < anchorIndex && stickyIndex < anchorTargetIndex || anchorTargetIndex > stickyIndex && anchorTargetIndex > anchorIndex) {
        spacer += $('.pharmacy-search-component-sticky-form').outerHeight();
      }
    }

    $('body,html').animate({
      scrollTop: $(aTag).offset().top - spacer,
    }, 1000);
  });
}



// WEBPACK FOOTER //
// ./scripts/components/anchor_scrolling.js